import axios from 'axios'
import * as HttpStatus from 'http-status-codes'

import { BrokerCarrierRelationshipFormPayload } from 'components/Brokers/BrokerCarrierRelationshipEdit'

export function upload(id: string, formData: any) {
  let url = `/api/v1/console/brokers/${id}/upload/`
  return axios
    .post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then((response) => {
      if (response.status === HttpStatus.OK) {
        return response.data
      }
    })
}

export function getBrokerCarrierRelationship(id: string) {
  return axios.get(`/api/v3/broker-carrier-relationships/${id}/`)
}

export function updateBrokerCarrierRelationship(id: string, data: BrokerCarrierRelationshipFormPayload) {
  return axios.put(`/api/v3/broker-carrier-relationships/${id}/`, data)
}

export function uploadCarrierAgreement(id: string, formData: any) {
  return axios.post(`/api/v3/broker-carrier-relationships/${id}/upload/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}
